/* eslint-disable @typescript-eslint/ban-ts-comment */
import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/marmalade';
// @ts-ignore - Import issues with marmalade-icons
import LogoFacebook from '@eventbrite/marmalade-icons/react/LogoFacebook';
// @ts-ignore - Import issues with marmalade-icons
import LogoX from '@eventbrite/marmalade-icons/react/LogoX';
// @ts-ignore - Import issues with marmalade-icons
import SymbolGlobe from '@eventbrite/marmalade-icons/react/SymbolGlobe';
import React from 'react';
import { trackClickOnSocialWidget } from '../../tracking/analytics';
import './SocialWidgetNewLayout.scss';

type SocialPlatform = 'facebook' | 'twitter' | 'website';

export interface SocialWidgetNewLayoutProps {
    facebook?: string;
    twitter?: string;
    website?: string;
}

interface SocialLinkProps {
    url: string;
    icon: React.ComponentType;
    label: string;
    platform: SocialPlatform;
}

const SocialLink = ({
    url,
    icon: IconComponent,
    label,
    platform,
}: SocialLinkProps) => (
    <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
        onClick={() => trackClickOnSocialWidget(platform)}
        className="social-widget__icon-link"
    >
        <Icon>
            <IconComponent />
        </Icon>
    </a>
);

const socialPlatforms = [
    {
        key: 'facebook' as const,
        icon: LogoFacebook,
        baseUrl: 'https://www.facebook.com/',
        label: gettext('Facebook profile'),
    },
    {
        key: 'twitter' as const,
        icon: LogoX,
        baseUrl: 'https://www.twitter.com/',
        label: gettext('Twitter profile'),
    },
    {
        key: 'website' as const,
        icon: SymbolGlobe,
        baseUrl: '',
        label: gettext('Organizer website'),
    },
] as const;

export const SocialWidgetNewLayout = ({
    facebook,
    twitter,
    website,
}: SocialWidgetNewLayoutProps) => {
    const socialLinks = { facebook, twitter, website };

    return (
        <div className="social-widget--redesign">
            {socialPlatforms.map(({ key, icon, baseUrl, label }) => {
                const value = socialLinks[key];
                if (!value?.trim()) {
                    return null;
                }

                const url = baseUrl ? `${baseUrl}${value}` : value;
                return (
                    <SocialLink
                        key={key}
                        url={url}
                        icon={icon}
                        label={label.toString()}
                        platform={key}
                    />
                );
            })}
        </div>
    );
};
